<template>
  <div
    ref="videoContainer"
    class="single-video flex-grow-1 d-flex flex-column align-items-center justify-content-center"
    v-on:click.stop="showVideo"
    style="overflow: hidden; width: 100%; height: 100%"
  >
    <div
      ref="video"
      v-bind:id="'video-' + videoId"
      class="flex-grow-1 d-flex flex-column justify-content-center"
    ></div>
    <h5
      v-if="videoType === 2"
      class="my-2"
      :class="{'text-white':skinType}"
      style="cursor: pointer"
    >
      {{ videoUrl.NickName }}#监控
    </h5>
  </div>
</template>
<script>
import EZUIKit from 'ezuikit-js';

export default {
  name: 'area-video',
  props: {
    token: {
      type: String,
      default: '',
    },
    videoId: {
      default: 0,
    },
    videoType: {
      default: 2,
    },
    videoUrl: {
      default() {
        return null;
      },
      type: Object,
    },
  },
  data() {
    return {
      player: '',
      imgSrc: '',
      toId: '',
      fluorite_token: '',
    };
  },
  watch: {
    videoUrl() {
      if (this.player) {
        this.player.stop();
        this.player.play({
          url: `ezopen://open.ys7.com/${this.videoUrl.DeviceSerial}/${this.videoUrl.ChannelNo}.live`,
        });
        return;
      }
      this.initPlayer();
    },
  },
  mounted() {
    this.setSize();
    this.initPlayer();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    showVideo() {
      if (this.videoType !== 2) {
        return;
      }
      this.$emit('showVideo', this.videoUrl);
    },
    setSize() {
      const { videoContainer, video } = this.$refs;
      const width = videoContainer.clientWidth;
      const height = videoContainer.clientHeight;
      if ((width / 16) * 9 > height) {
        video.style.height = `${height}px`;
        // eslint-disable-next-line no-mixed-operators
        video.style.width = `${Math.floor((height / 9) * 16)}px`;
      } else {
        video.style.width = `${width}px`;
        // eslint-disable-next-line no-mixed-operators
        video.style.height = `${Math.floor((width / 16) * 9)}px`;
      }
      console.log('video', video);
      video.classList.remove('none-height');
      video.classList.remove('flex-grow-1');
      video.parentElement.classList.remove('flex-grow-1');
    },
    initPlayer() {
      if (this.videoUrl === null) {
        return;
      }
      if (!this.token) {
        return;
      }
      const url = `ezopen://open.ys7.com/${this.videoUrl.DeviceSerial}/${this.videoUrl.ChannelNo}.live`;
      console.log(
        'this.videoUrl',
        this.videoUrl,
        'this.token',
        this.token,
        'this.url',
        url,
      );
      this.player = new EZUIKit.EZUIKitPlayer({
        autoplay: true,
        id: `video-${this.videoId}`,
        accessToken: this.token,
        url,
      });
    },
    getUUID(str) {
      const arr = str.split('/');
      console.log('arr', arr);
      return arr[arr.length - 1];
    },
  },
};
</script>
<style scoped>
.col-4 {
  padding: 0px;
}
.direction-control {
  font-size: 1.3rem;
  width: 2.5rem;
  height: 2.5rem;
}
.display-zero {
  width: 0;
  height: 0;
}
.control-container {
  position: absolute;
  left: 0.5rem;
  bottom: 0.5rem;
  width: 7.5rem;
  height: 7.5rem;
  padding: 0.4rem;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
}
.control_left {
  float: left;
}
.control_right {
  float: right;
}
.img-fluid {
  height: 100%;
  width: auto;
}
.video_box {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
